var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 8,
    fill: "url(#paint0_linear_580_114)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_580_114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0108 37.8796C42.0108 41.6782 38.9204 44.7687 35.1218 44.7687C31.3231 44.7687 28.2327 41.6782 28.2327 37.8796C28.2327 34.0808 31.3231 30.9903 35.1218 30.9903C36.5242 30.9903 37.8293 31.4126 38.9189 32.1351L42.914 28.1399C42.8239 28.074 42.7333 28.0084 42.6411 27.944C39.9317 26.0506 37.2177 25.0938 34.5628 25.0938C34.3196 25.0938 34.0771 25.1017 33.835 25.1178C30.6316 25.3358 27.6473 26.7619 25.4338 29.1331C23.2148 31.5064 21.9932 34.6123 21.9932 37.8796C21.9932 41.3851 23.3591 44.6817 25.8393 47.1619C28.3196 49.6423 31.6161 51.0081 35.1217 51.0081C38.6272 51.0081 41.9238 49.6422 44.4041 47.1619C46.8843 44.6816 48.2501 41.3851 48.2501 37.8796C48.2501 34.994 47.0848 32.2238 44.981 29.9673L40.8659 34.0824C41.5887 35.1719 42.0108 36.4772 42.0108 37.8796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1488 36.9039L36.9056 34.147C36.3654 33.8877 35.7607 33.7422 35.1225 33.7422C32.8423 33.7422 30.9873 35.5973 30.9873 37.8775C30.9873 40.1577 32.8423 42.0127 35.1225 42.0127C37.4026 42.0127 39.2577 40.1577 39.2577 37.8775C39.2577 37.2394 39.1122 36.6345 38.8529 36.0943L36.0962 38.8511L34.1488 36.9039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6433 26.3058L46.93 28.0191C49.5501 30.7933 51.0044 34.2507 51.0044 37.8799C51.0044 42.1211 49.352 46.1091 46.3516 49.1095C43.3512 52.11 39.3631 53.7624 35.1219 53.7624C30.8808 53.7624 26.8927 52.11 23.8922 49.1095C20.8918 46.1091 19.2394 42.121 19.2394 37.8799C19.2394 33.9117 20.7248 30.1378 23.4217 27.2534C26.1125 24.3706 29.7456 22.6361 33.6505 22.3703C37.1802 22.1371 40.7346 23.2521 44.2187 25.687C44.4449 25.845 44.6649 26.0079 44.8809 26.1737L46.6961 24.3585L46.9868 19.2003C43.4733 16.959 39.3901 15.7579 35.122 15.7579C29.2131 15.7579 23.6577 18.059 19.4795 22.2372C15.3011 26.4155 13 31.9708 13 37.8798C13 43.7888 15.3011 49.3441 19.4794 53.5223C23.6577 57.7006 29.213 60.0017 35.1219 60.0017C41.0309 60.0017 46.5863 57.7007 50.7645 53.5223C54.9427 49.344 57.2438 43.7888 57.2438 37.8798C57.2438 33.6117 56.0426 29.5285 53.8014 26.015L48.6433 26.3058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5029 23.4973L55.1299 23.1802L60.0003 18.3097L54.6906 13L49.8202 17.8704L49.5029 23.4973Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_580_114",
    x1: 2,
    y1: 2.5,
    x2: 71,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_580_114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame2.ed3a4342708caf73b764228f8efab644.svg";
export { ForwardRef as ReactComponent };